export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CheckboxImage.vue?vue&type=template&id=616e195c&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/CheckboxImage.vue?vue&type=template&id=616e195c&
// module id = 1111
// module chunks = 0